import { useFormContext, Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

type TextBoxProps = {
  name: string;
} & Omit<React.ComponentProps<typeof TextField>, 'name'>;

const TextBox = ({ name, helperText, ...other }: TextBoxProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          error={!!error}
          helperText={error?.message || helperText}
          {...other}
        />
      )}
    />
  );
};

export default TextBox;
